import React from "react";

const PageHeader = ({ title, subtitle, children }) => {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-8 md:py-12">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold text-[#111827] mb-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {subtitle}
            </p>
          )}
          {children && <div className="mt-6">{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
